var _ = require('ES/lib/lodash');

module.exports = function (event, Displaylists, show_new_event_form, error_msg, saving) {
	return (saving || _.isEmpty(_.get(Displaylists, ["sitelists"])) || _.isEmpty(_.get(Displaylists, ["universal"])) || (!show_new_event_form && _.isEmpty(event))) && !error_msg;
};



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/isLoading.js